/**
 * Standard page chrome: header (icon + title + optional subtitle + actions)
 * + scrollable content. Used by every dashboard page so titles stay visually
 * consistent across the app.
 */
export function PageShell({ icon, title, subtitle, actions, children }) {
  return (
    <div className="flex h-full flex-1 flex-col overflow-hidden">
      <header className="flex items-center justify-between gap-4 border-b border-line bg-white px-8 py-5">
        <div className="flex min-w-0 items-center gap-3">
          {icon && (
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-accent-soft text-accent">
              <i className={`fa-solid ${icon} text-lg`} aria-hidden="true" />
            </div>
          )}
          <div className="min-w-0">
            <h1 className="truncate text-xl font-semibold tracking-tight text-ink">{title}</h1>
            {subtitle && <p className="mt-0.5 truncate text-sm text-mist">{subtitle}</p>}
          </div>
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </header>

      <main className="flex-1 overflow-y-auto bg-canvas px-8 py-8 scrollbar-thin">
        {children}
      </main>
    </div>
  );
}

export function PlaceholderCard({ icon, title, description }) {
  return (
    <div className="card flex flex-col items-center justify-center px-8 py-16 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-accent-soft text-accent">
        <i className={`fa-solid ${icon} text-xl`} aria-hidden="true" />
      </div>
      <h2 className="text-lg font-semibold text-ink">{title}</h2>
      <p className="mt-1 max-w-md text-sm text-mist">{description}</p>
    </div>
  );
}
